module.exports = __webpack_public_path__ + "img/nfp-2.5211ee0d.png";